export enum PropertyName{
    ComponentType = "ComponentType",
    Xcv = "Xcv",
    UserRoleName = "UserRoleName",
    EventType = "EventType",
    MsitPartB = "MsitPartB",
    StartDateTime = "StartDateTime",
    EndDateTime = "EndDateTime",
    TemplateType = "TemplateType",
    BusinessProcessName = "BusinessProcessName",
    TargetEntityKey = "TargetEntityKey",
    AppAction = "AppAction",
    ActionUri = "ActionUri",
    SenderId = "SenderId",
    ReceiverId = "ReceiverId",
    MessageId = "MessageId",
    EventOccurrenceTime = "EventOccurrenceTime",

}